// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_gr-0";
export var optionCard = "_gr-1";